import {Component, Inject, Input, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';

@Component({
             selector: 'app-delete-form',
             templateUrl: './home-assistance-delete-dialog.component.html'
           })
export class HomeAssistanceDeleteDialogComponent implements OnInit {

  @Input() deleteTitle = this.translateService.instant('archive-assistance');
  @Input() deleteMessage = this.translateService.instant('delete-message');

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public translateService: TranslateService) {
  }

  ngOnInit(): void {
    if (this.data.deleteTitle != null) {
      this.deleteTitle = this.data.deleteTitle;
    }
    if (this.data.deleteMessage != null) {
      this.deleteMessage = this.data.deleteMessage;
    }
  }
}
